/** Best-effort short preview of a feedback message payload for the event ticker. */
export function feedbackPreview(payload: unknown): string {
  if (typeof payload === "string") return payload.trim();
  if (payload && typeof payload === "object") {
    const p = payload as Record<string, unknown>;
    for (const key of ["message", "phase", "content", "output"]) {
      const value = p[key];
      if (typeof value === "string") return value.trim();
    }
  }
  return "";
}
